var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "账号信息", width: 60 },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.$globalSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Form",
        {
          ref: "userBinFenCustomerForm",
          staticClass: "small-form",
          attrs: {
            model: _vm.userBinFenCustomerForm,
            rules: _vm.ruleValidate,
            "label-position": "top",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "登录帐号", prop: "userName" } },
                    [
                      _c("Input", {
                        attrs: {
                          readonly:
                            _vm.formEditMode === _vm.FORM_EDIT_MODE_MODIFY,
                        },
                        model: {
                          value: _vm.userBinFenCustomerForm.userName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userBinFenCustomerForm,
                              "userName",
                              $$v
                            )
                          },
                          expression: "userBinFenCustomerForm.userName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "姓名",
                        prop: "userExternalCustomerName",
                      },
                    },
                    [
                      _c("Input", {
                        model: {
                          value:
                            _vm.userBinFenCustomerForm.userExternalCustomerName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userBinFenCustomerForm,
                              "userExternalCustomerName",
                              $$v
                            )
                          },
                          expression:
                            "userBinFenCustomerForm.userExternalCustomerName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "所属区域",
                        prop: "userExternalCustomerAreaUuid",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value:
                              _vm.userBinFenCustomerForm
                                .userExternalCustomerAreaUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userBinFenCustomerForm,
                                "userExternalCustomerAreaUuid",
                                $$v
                              )
                            },
                            expression:
                              "userBinFenCustomerForm.userExternalCustomerAreaUuid",
                          },
                        },
                        _vm._l(_vm.areaSource, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.areaUuid,
                              attrs: { value: item.areaUuid },
                            },
                            [_vm._v(_vm._s(item.areaName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "所属部门", prop: "departmentUuid" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value: _vm.userBinFenCustomerForm.departmentUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userBinFenCustomerForm,
                                "departmentUuid",
                                $$v
                              )
                            },
                            expression: "userBinFenCustomerForm.departmentUuid",
                          },
                        },
                        _vm._l(_vm.departments, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.departmentUuid,
                              attrs: { value: item.departmentUuid },
                            },
                            [_vm._v(_vm._s(item.departmentName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "公司名称" } },
                    [
                      _c("Input", {
                        model: {
                          value:
                            _vm.userBinFenCustomerForm
                              .userExternalCustomerCompanyName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userBinFenCustomerForm,
                              "userExternalCustomerCompanyName",
                              $$v
                            )
                          },
                          expression:
                            "userBinFenCustomerForm.userExternalCustomerCompanyName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "省份",
                        prop: "userExternalCustomerProvinceUuid",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value:
                              _vm.userBinFenCustomerForm
                                .userExternalCustomerProvinceUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userBinFenCustomerForm,
                                "userExternalCustomerProvinceUuid",
                                $$v
                              )
                            },
                            expression:
                              "userBinFenCustomerForm.userExternalCustomerProvinceUuid",
                          },
                        },
                        _vm._l(_vm.provinceOptions, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.regionUuid,
                              attrs: { value: item.regionUuid },
                            },
                            [_vm._v(_vm._s(item.regionName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "城市",
                        prop: "userExternalCustomerCityUuid",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value:
                              _vm.userBinFenCustomerForm
                                .userExternalCustomerCityUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userBinFenCustomerForm,
                                "userExternalCustomerCityUuid",
                                $$v
                              )
                            },
                            expression:
                              "userBinFenCustomerForm.userExternalCustomerCityUuid",
                          },
                        },
                        _vm._l(_vm.cityOptions, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.regionUuid,
                              attrs: { value: item.regionUuid },
                            },
                            [_vm._v(_vm._s(item.regionName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "区域",
                        prop: "userExternalCustomerDistUuid",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value:
                              _vm.userBinFenCustomerForm
                                .userExternalCustomerDistUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userBinFenCustomerForm,
                                "userExternalCustomerDistUuid",
                                $$v
                              )
                            },
                            expression:
                              "userBinFenCustomerForm.userExternalCustomerDistUuid",
                          },
                        },
                        _vm._l(_vm.distOptions, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.regionUuid,
                              attrs: { value: item.regionUuid },
                            },
                            [_vm._v(_vm._s(item.regionName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "手机", prop: "userExternalCustomer" } },
                    [
                      _c("Input", {
                        model: {
                          value:
                            _vm.userBinFenCustomerForm
                              .userExternalCustomerPhone,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.userBinFenCustomerForm,
                              "userExternalCustomerPhone",
                              $$v
                            )
                          },
                          expression:
                            "userBinFenCustomerForm.userExternalCustomerPhone",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "客户经理",
                        prop: "userExternalCustomerRelateCustomerManagerUuid",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "" },
                          model: {
                            value:
                              _vm.userBinFenCustomerForm
                                .userExternalCustomerRelateCustomerManagerUuid,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userBinFenCustomerForm,
                                "userExternalCustomerRelateCustomerManagerUuid",
                                $$v
                              )
                            },
                            expression:
                              "userBinFenCustomerForm.userExternalCustomerRelateCustomerManagerUuid",
                          },
                        },
                        _vm._l(_vm.userCustomerManagerSource, function (item) {
                          return _c(
                            "Option",
                            {
                              key: item.userCustomerManagerLoginUuid,
                              attrs: {
                                value: item.userCustomerManagerLoginUuid,
                              },
                            },
                            [_vm._v(_vm._s(item.userCustomerManagerName))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "审批" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button" },
                          model: {
                            value:
                              _vm.userBinFenCustomerForm
                                .userExternalCustomerApproval,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.userBinFenCustomerForm,
                                "userExternalCustomerApproval",
                                $$v
                              )
                            },
                            expression:
                              "userBinFenCustomerForm.userExternalCustomerApproval",
                          },
                        },
                        _vm._l(_vm.approvalSource, function (item) {
                          return _c(
                            "Radio",
                            { key: item.val, attrs: { label: item.val } },
                            [
                              _vm._v(
                                _vm._s(item.label) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.formEditMode === _vm.FORM_EDIT_MODE_CREATE
                ? _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "密码" } },
                        [
                          _c("Input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.password,
                              callback: function ($$v) {
                                _vm.password = $$v
                              },
                              expression: "password",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.formEditMode === _vm.FORM_EDIT_MODE_CREATE
                ? _c(
                    "Col",
                    { attrs: { span: "6" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "密码确认" } },
                        [
                          _c("Input", {
                            attrs: { type: "password" },
                            model: {
                              value: _vm.passwordConfirm,
                              callback: function ($$v) {
                                _vm.passwordConfirm = $$v
                              },
                              expression: "passwordConfirm",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("确认")]
          ),
          _c(
            "Button",
            {
              attrs: { type: "error" },
              on: {
                click: function ($event) {
                  _vm.show = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }